module.exports = __webpack_public_path__ + "static/img/tijiaoshengqing_134@2x.09fdc35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tijiaoshengqing_134@2x.png
// module id = 309
// module chunks = 1